export function remove_url_parameter(url, parameter, encodedUri = true) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
        var prefix = encodedUri ? encodeURIComponent(parameter) : (parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);
        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}

export function downloadAttachment(src, name) {
    fetch(src)
        .then(response => response.blob())
        .then(blob => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = name;
            link.click();
        })
        .catch(console.error);
}

export function phoneFormat(phone, mask = "+#(###) ###-##-##") {
    var value = phone?.trim().replace(/[^\d]/g, '') || '';
    var i = 0;
    var lastReplacedIndex = -1;
    const filledMask = mask.replace(/#/g, (_, index) => {
        if (i >= value.length) return ' ';
        lastReplacedIndex = index;
        return value[i++];
    });
    return filledMask.substring(0, lastReplacedIndex + 1);
}

export function isObj(item) {
    return (typeof item === "object" && !Array.isArray(item) && item !== null);
}

export function stripHtml(html)
{
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}

export function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
}

export function update_query_string_parameter(uri, key, value) {
    var re = new RegExp("([?&])" + escapeRegExp(key) + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        return uri + separator + key + "=" + value;
    }
}

export function isState(val) {
    if(val === null) return val;
    if(val?.length) return false;
    return null
}

export function checkValidation(key) {
    return Object.keys(this[key]).map((f) => {
        if (this[`${f}Valid`]) return this[`${f}Valid`].apply(this, [key]);
        return true;
    }).every(f => f)
}

export function phoneValid(key) {
    this.validations.phone = '';
    if(!this[key].phone?.trim().length) this.validations.phone = 'введите телефон';
    else if (this[key].phone?.trim().length <= 8) this.validations.phone = 'телефон не меньше 8 цифр';
    else if (!/^\+?\d+$/.test(this[key].phone)) this.validations.phone = 'телефон должен состоять из цифр';
    return !this.validations.phone.length
}

export function composePhoto(photo) {
    if(photo.match(/^(ftp|https?):\/\/+(www\.)?/)) return photo;
    else return 'https://storage.hr-crm.io/applicants_photos/'+photo;

}

export function emailValid(key) {
    this.validations.email = '';
    if(!this[key].email?.trim().length) this.validations.email = 'введите email';
    else if (!/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this[key].email)) {
        this.validations.email = 'неверный email';
    }
    return !this.validations.email.length
}

export function cookie_format (param = {}) {
    return Object.entries(param).map(([k, v]) => `${k}=${v}`).join(';')
}

export function get_query_search_param(query) {
    return query
        ? (/^[?#]/.test(query) ? query.slice(1) : query)
            .split('&')
            .reduce((params, param) => {
                    let [key, value] = param.split('=');
                    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                    return params;
                }, {}
            )
        : {}
}

export function escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export function debounce (fn, delay) {
    var timeoutID = null
    return function () {
        clearTimeout(timeoutID)
        var args = arguments
        var that = this
        timeoutID = setTimeout(function () {
            fn.apply(that, args)
        }, delay)
    }
}

export function calcObjects(PivotObj, adding = {}) {
    Object.entries(adding).forEach(([key, num]) => {
        if(PivotObj[key]) {
            PivotObj[key] = PivotObj[key] + num.amount
        } else PivotObj[key] = num.amount
    })
    return PivotObj;
}

export function ownerTitle() {
    return (u = {last_name: '', first_name: '', sur_name: ''}) => [u.first_name, u.last_name, u.sur_name]
        .map((n,i) => n?.length && i !== 0 ? `${n.slice(0,1).toUpperCase()}.` : n).filter(n => n !== null).join(' ')
}

export function usersTitle() {
    return (users, sep = ', ') => users.map(({last_name, first_name, sur_name}) => [first_name, last_name]
        .map((n,i) => n?.length && i !== 0 ? `${n.slice(0,1).toUpperCase()}.` : n).filter(n => n !== null).join(' ')).join(sep)
}

export function dateTo (date, time = false, sep = 'в') {
    return `${new Date(date).toLocaleDateString()}${time ? ` ${sep} ` + new Date(date).toLocaleTimeString().substr(0,5) : ''}`
}
export function days_between(date1, date2) {

    // The number of milliseconds in one day
    const ONE_DAY = 1000 * 60 * 60 * 24;

    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(date1 - date2);

    // Convert back to days and return
    return Math.round(differenceMs / ONE_DAY);

}

function toIsoString(date) {
    var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            return (num < 10 ? '0' : '') + num;
        };

    return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds()) +
        dif + pad(Math.floor(Math.abs(tzo) / 60)) +
        ':' + pad(Math.abs(tzo) % 60);
}

export function dateStr (date = null, addedDays = 0) {
    let D = new Date(date ? date : new Date())
    if(addedDays) D = new Date(D.setDate(D.getDate() + addedDays));
    return toIsoString(D).split('T')[0]
}

export function toLocalStrNotSec(date, withOutMin) {
    return date.toLocaleString().slice(0,withOutMin ? -10 : -3)
}

export function timeStr (date) {
    return toIsoString(new Date(date || new Date())).split('T')[1].split('.')[0].replace(/\+.*/, '')
}

export function implodeDateStrToD (date, time = '') {
    const [hours, min] = time?.split(':') || []
    const D = new Date(date);
    if(hours)     D.setHours(+hours)
    if(min)     D.setMinutes(+min)

    return D;
}

export function isMobWidth() {
    return (window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth) <= 992;
}

export function compareDesc(key) {
    return (a, b) => {
        if (a[key] < b[key] ){
            return 1;
        }if (a[key] > b[key] ) {
            return -1;
        }
        return 0;
    }
}

export const REFUSES_COL_MAP = {
    5: '#7AB8D8', 4: '#1F78B4', 3: '#B2DF8A', 2: '#33A02C', 1: '#FB9A99', 6: '#E31A1C', 7: '#FDBF6F', 8: '#FF7F00', 9: '#CAB2D6', 10: '#6A3D9A',
    11: '#455d7a', 12: '#f95959', 13: '#e3e3e3', 14: '#9fd3c7', 15: '#f96d00', 16: '#5c5470', 17: '#7c73e6', 18: '#a2c11c', 19: '#bbe9db', 20: '#ebd5d5',
}


export const getPermissions = (constraints = null) => {
    // Older browsers might not implement mediaDevices at all, so we set an empty object first
    if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
    }

    // Some browsers partially implement mediaDevices. We can't just assign an object
    // with getUserMedia as it would overwrite existing properties.
    // Here, we will just add the getUserMedia property if it's missing.
    if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
            // First get ahold of the legacy getUserMedia, if present
            const getUserMedia =
                navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

            // Some browsers just don't implement it - return a rejected promise with an error
            // to keep a consistent interface
            if (!getUserMedia) {
                return Promise.reject(
                    new Error("getUserMedia is not implemented in this browser")
                );
            }

            // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
            return new Promise((resolve, reject) => {
                getUserMedia.call(navigator, constraints, resolve, reject);
            });
        };
    }
    navigator.mediaDevices.getUserMedia =
        navigator.mediaDevices.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia;

    return new Promise((resolve, reject) => {
        let param = { video: true, audio: true }
        if(constraints !== null) param = constraints
        navigator.mediaDevices
            .getUserMedia(param)
            .then(stream => {
                resolve(stream);
            })
            .catch(err => {
                console.log('navigator err' , err)
                reject(err);
                //   throw new Error(`Unable to fetch stream ${err}`);
            });
    });
};
